export const formatDate = (date, isLongMonthName) => {
  if (!date) {
    return date;
  }
  const dateparts = date.split('-');
  const formattedDate = new Date(dateparts[0], dateparts[1] - 1, dateparts[2], 0, 0, 0);
  const longMonthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];
  const shortMonthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  if (isLongMonthName) {
    return longMonthNames[formattedDate.getMonth()] + ' ' + formattedDate.getDate();
  }
  return shortMonthNames[formattedDate.getMonth()] + ' ' + formattedDate.getDate();
};

export const formatWeek = (date, isLongDayName) => {
  if (!date) {
    return date;
  }
  const dateparts = date.split('-');
  const formattedDate = new Date(dateparts[0], dateparts[1] - 1, dateparts[2], 0, 0, 0);
  const longWeekNames = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
  ];
  const shortWeekNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  if (isLongDayName) {
    return longWeekNames[formattedDate.getDay()];
  }
  return shortWeekNames[formattedDate.getDay()];
};

export const isMobile = (channel) => {
  return channel?.toLowerCase() === 'mobile';
};

export const isSthAndInStock = ({ availableFulfillments, isOutOfStockOnline }) => {
  return availableFulfillments.indexOf('ShipToHome') > -1 && !isOutOfStockOnline;
};

export const getDeliveryZip = () => {
  let zipCode = '';
  try {
    if (typeof window !== 'undefined') {
      const zipDetails = window?.THD_LOCALIZER_AUTO_INIT?.Localizer?.getDeliveryZipcodeDetails();
      zipCode = zipDetails?.zipcode;
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
  return zipCode;
};

export const skuGroupingForReturnInStore = [/^25-9-/, /25-10-38/, /25-5-6/, /25-12-2/, /25-12-3/, /25-12-4/,
  /25-12-6/, /25-12-7/, /25-12-15/, /25-12-20/, /25-28-2/, /25-28-4/, /25-28-5/, /25-28-6/, /25-28-10/,
  /25-28-11/, /25-28-12/, /25-28-60/, /26-2-15/, /^27-1-(25|26|29|30|36)/, /27-2-4/, /27-2-15/, /27-3-5/,
  /27-3-6/, /27-5-11/, /27-8-3/, /27-11-4/, /27-11-8/, /27-18-11/, /27-31-3/, /27-31-4/, /27-31-7/, /27-31-8/,
  /27-31-9/, /27-31-14/, /27-31-19/, /27-31-20/, /27-31-21/, /28-32-6/, /29-16-5/, /29-16-12/, /29-17-2/, /29-17-7/,
  /29-32-6/];

export const fencingItemsGroup = [/^21-8-/];